import { getRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";

export const getERPStatusList = async () => {
  try {
    return await getRequest(urls.ERP_STATUS_LIST);
  } catch (err) {
    return err;
  }
};
